"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const input_dialog_1 = require("../input-dialog");
const SwitchButton = "switch";
const DefaultFalseText = "Off";
const DefaultTrueText = "On";
class BooleanDialog extends input_dialog_1.default {
    constructor(_booleanDialogConfig = {}) {
        super(_booleanDialogConfig);
        this._booleanDialogConfig = _booleanDialogConfig;
    }
    get bodySelector() {
        const selector = this._booleanDialogConfig.bodySelector || ".boolean-modal-body";
        return `${this.rootSelector} ${selector}`;
    }
    get falseText() {
        return this._booleanDialogConfig.falseText || DefaultFalseText;
    }
    get trueText() {
        return this._booleanDialogConfig.trueText || DefaultTrueText;
    }
    get switchButton() {
        return SwitchButton; // name of the switch button
    }
    get falseValue() {
        return "False";
    }
    get trueValue() {
        return "True";
    }
    setInputValue(value) {
        const isChecked = value === this.trueValue;
        $("#switch").jqxSwitchButton({ checked: isChecked, height: 27, width: 81, offLabel: this._booleanDialogConfig.falseText, onLabel: this._booleanDialogConfig.trueText });
    }
    getInputValue() {
        const isChecked = $("#switch").jqxSwitchButton("val");
        return isChecked ? this.trueValue : this.falseValue;
    }
    getBooleanValue() {
        return this.getInputValue() !== this.falseValue;
    }
    focusInput() {
        // nothing to do here
    }
    selectInput() {
        // nothing to do here
    }
    clearInputValue() {
        // nothing to do here
    }
    handleButtonClick(buttonIdentifier, resultCallback) {
        super.handleButtonClick(buttonIdentifier, resultCallback);
    }
    toString() {
        return "Boolean Dialog";
    }
}
exports.default = BooleanDialog;
